const fbBatchRequest = async (url, accessToken, batch) => {
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            access_token: accessToken,
            batch: batch,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const json = await response.json();

    return json.reduce((acc, currVal) => {
        const { code, body } = currVal;
        if (code === 200) acc.push(JSON.parse(body));
        return acc;
    }, []);
};

export default fbBatchRequest;
